export default __webpack_public_path__ + "static/media/Trophy.5ede7c4d.gif";